import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CountryStore from "../store/CountryStore";
import axios from "axios";
import CategoryStore from "../store/CategoryStore";
import { ClipLoader } from "react-spinners";
import CategoryListStore from "../store/CategoryListStore";
import Pagination from "../components/Pagination";

function Sitemap() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("panel");
  const [categoryData, setCategoryData] = useState([]);
  const [slugs, setSlugs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(400);
  const setGlobalCountry = CountryStore((state) => state.setCountry);
  const globalCategoryList = CategoryListStore((state) => state.categoryList);
  const globalCountry = CountryStore((state) => state.country);

  useEffect(() => {
    setCategoryData(Object.keys(globalCategoryList));
  }, []);

  async function fetchSlugs() {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("cat_slug", activeTab);
      const response = await axios.post(
        "/api/site_map.php",
        formData
      );
      // console.log(response.data);

      const countrySpecificData = response.data.filter(
        (item) => item.country === globalCountry
      );

      const uniqueSlugs = [...new Set(countrySpecificData.map((item) => item.slug))];

      const uniqueData = uniqueSlugs.map((slug) => {
        return response.data.find((item) => item.slug === slug);
      });

      setSlugs(uniqueData);
    } catch (e) {
      console.error("Error fetching slugs:", e);
      setSlugs([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchSlugs();
  }, [activeTab]);

  function handleCategoryClick(category_slug) {
    setActiveTab(category_slug);
    setCurrentPage(1); // Reset to first page when changing category
  }

  const setGlobalCategory = CategoryStore((state) => state.setCategory);

  function handleSiteClick(country, slug) {
    setGlobalCategory(activeTab[0].toUpperCase() + activeTab.slice(1));
    const formattedCountry = country.replace(/\s+/g, "-").toLowerCase();
    navigate(`/${formattedCountry}/${activeTab}/${slug}`, { state: { slug } });
  }

  function cleanText(item) {
    const cleanedText = item.slug.replace(/-/g, ' ');
    return cleanedText[0].toUpperCase() + cleanedText.slice(1);
  }

  // Pagination logic
  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentSlugs = slugs.slice(firstPostIndex, lastPostIndex);

  return (
    <div className="font-inter mx-2 sm:mx-0 mb-2">
      <div className="py-4 font-inter border-b-2 border-gray-300">
        <h3 className="text-2xl font-semibold mb-4">
          {globalCountry}
        </h3>
        <div className="flex flex-wrap gap-4 space-x-6">
          {categoryData.map((category) => (
            <button
              key={category}
              onClick={() => handleCategoryClick(category)}
              className={`pb-1 text-lg ${
                activeTab === category
                  ? "border-b-2 border-black text-black"
                  : "text-[#9CA3AF]"
              } hover:text-black transition`}
            >
              {category[0].toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>

        <div className="border b-2 mb-4"></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {loading ? (
            <div className="absolute inset-0 flex justify-center items-center">
              <ClipLoader color="#006b4f" size={35} speedMultiplier={1} />
            </div>
          ) : (
            currentSlugs && currentSlugs.length > 0 ? currentSlugs.map((item, index) => (
              <button
                key={index}
                className="text-[#9CA3AF] hover:text-black hover:underline text-sm text-left cursor-pointer break-words"
                onClick={() => handleSiteClick(item.country, item.slug)}
                style={{ pointerEvents: 'none' }}
              >
                <span style={{ pointerEvents: 'auto' }}>
                  {cleanText(item)}
                </span>
              </button>
            )) :
              <div className="text-[#9CA3AF]">No {activeTab + 's'} found in {globalCountry}.</div>
          )}
        </div>

        {!loading && slugs.length > postsPerPage && (
          <div className="mt-8">
            <Pagination
              totalPosts={slugs.length}
              postsPerPage={postsPerPage}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Sitemap;